import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=4e13e216&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13e216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e13e216')) {
      api.createRecord('4e13e216', component.options)
    } else {
      api.reload('4e13e216', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=4e13e216&scoped=true", function () {
      api.rerender('4e13e216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/modular/components/edit.vue"
export default component.exports